export default "__VITE_ASSET__75b10122__"